__turbopack_context__.v({
  "grid2Columns": "tweet-media-module__TReg5a__grid2Columns",
  "grid2x2": "tweet-media-module__TReg5a__grid2x2",
  "grid3": "tweet-media-module__TReg5a__grid3",
  "image": "tweet-media-module__TReg5a__image",
  "mediaContainer": "tweet-media-module__TReg5a__mediaContainer",
  "mediaLink": "tweet-media-module__TReg5a__mediaLink",
  "mediaWrapper": "tweet-media-module__TReg5a__mediaWrapper",
  "root": "tweet-media-module__TReg5a__root",
  "rounded": "tweet-media-module__TReg5a__rounded",
  "skeleton": "tweet-media-module__TReg5a__skeleton",
});
